import React, { useEffect, useState, useRef } from "react";
import style from "./About.module.css";
import AboutImage from "../../assets/aspiron_about.png";
import TimeLine from "../TimeLine/TimeLine";
import Digitalization from "./Digitalization";
import Foundingteam from "./Foundingteam";
import OurClints from "./OurClints";
import home_style from "../Home/Home.module.css";
import "./AboutNew.css";

const About = () => {
  const sectionRef = useRef(null);
  const [products, setProducts] = useState(0);
  const [projects, setProjects] = useState(0);
  const [clients, setClients] = useState(0);
  const [employees, setEmployees] = useState(0);
  const [isTimelineVisible, setTimelineVisible] = useState(false);
  const animateCounter = (target, setState, duration) => {
    let current = 0;
    const increment = target / (duration / 10);
    const interval = setInterval(() => {
      current += increment;
      if (current >= target) {
        current = target;
        clearInterval(interval);
      }
      setState(Math.floor(current));
    }, 10);
  };

  useEffect(() => {
    const checkScroll = () => {
      const timelineElement = document.getElementById("timeline");
      const rect = timelineElement.getBoundingClientRect();

      if (rect.top <= window.innerHeight && rect.bottom >= 0) {
        setTimelineVisible(true);
      }
    };

    window.addEventListener("scroll", checkScroll);
    return () => window.removeEventListener("scroll", checkScroll);
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          console.log("Section is visible. Animating counters...");
          setProducts(0);
          setProjects(0);
          setClients(0);
          setEmployees(0);

          animateCounter(15, setProducts, 1000);
          animateCounter(2, setProjects, 1000);
          animateCounter(40, setClients, 1500);
          animateCounter(100, setEmployees, 2000);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    } else {
      console.error("sectionRef is not attached to any element!");
    }

    return () => {
      if (observer && sectionRef.current) observer.disconnect();
    };
  }, []);

  return (
    <div className="About_Main_container">
      <div className="About_FistDiv_container">
        <div className="About_Left_Container">
          <h1>Transformative Solutions for Educational Excellence</h1>
          <p>
            We are a leading software solutions company where innovation meets
            education and is dedicated to revolutionizing the educational
            landscape through cutting-edge technologies tailored for academic
            institutions.
          </p>
        </div>
        <div className="About_Right_Container">
          <img src={AboutImage} alt="img"/>
        </div>
      </div>

      <div className="About_SecondDiv_container">
        <div className="About_Left_Container_card">
          <h1>Our Vision</h1>
          <p>
            To revolutionize the educational landscape <br />
            globally by integrating advanced technology <br />
            and innovative solutions, empowering instit <br />
            -utions to achieve unparalleled academic <br />
            excellence and operational efficiency
          </p>
        </div>
        <div className="About_Right_Container_card">
          <h1>Our Mission</h1>
          <p>
            At Aspiron Technologies, our mission is to <br />
            empower educational institutions with transformative software
            solutions that <br />
            enhance efficiency, elevate teaching and <br />
            learning experiences, and ultimately contribute <br />
            to the advancement of education on a global scale.
          </p>
        </div>
      </div>

      <div className={style.storydecade}>
        <div className={style.joinbtn_cntr}>
          <h1>Our story of a decade</h1>
          <a href="/careers" style={{width:"25%"}}>
          <button >Join Us</button>
          </a>
        </div>
        <div className={style.RoadMap_img} id="timeline">
          {isTimelineVisible && <TimeLine />}
        </div>
      </div>
     

      <div>
        <Digitalization />
      </div>

      <div className={style.commitment_bg_cnt}>
        <h1 style={{ textShadow: "1px 1px 0px rgba(0,0,0,0.6)" }}>
          Our Commitment to Excellence
        </h1>
        <div
          className={`${style.commitment_card_cnt} ${style.card_1}`}
          data-animate
        >
          <h1>Continuous Improvement</h1>
          <p>
            We believe in the power of continuous improvement. Our software
            solutions are designed to evolve alongside the ever-changing
            landscape of education, ensuring that your institution stays ahead
            of the curve.
          </p>
        </div>

        <div
          className={`${style.commitment_card_cnt} ${style.card_2}`}
          data-animate
        >
          <h1>Collaboration and Partnership</h1>
          <p>
            We see our clients as partners in the journey towards educational
            excellence. Through collaboration, we work together to identify
            challenges, devise solutions, and achieve shared goals.
          </p>
        </div>

        <div
          className={`${style.commitment_card_cnt} ${style.card_3}`}
          data-animate
        >
          <h1>Data Security and Compliance</h1>
          <p>
            The security of your institution's data is our top priority. Our
            solutions adhere to the highest standards of data security and
            comply with relevant regulations to ensure the confidentiality and
            integrity of your information.
          </p>
        </div>
      </div>
      <div>
        <Foundingteam />
      </div>
      <div>
        <OurClints />
      </div>
      <br />

      <div className={style.join_bg_cnt}>
        <h1>Join Us in Shaping the Future of Education</h1>
        <p>
          At Aspiron Technologies, we are not just a software solutions
          provider; we are catalysts for positive change in the educational
          sphere. Join us in shaping the future of education through innovative,
          user-centric, and transformative solutions.
        </p>
      </div>
      <div ref={sectionRef} className={`${style.Clients} about-rating`}>
        <div className="about-rating-content">
          <h1 className="about-rating-title">User Growth & Engagement</h1>
          <p className="about-rating-description">
            We prioritize initiatives that facilitate the growth and active
            participation of students, faculty, staff, and other stakeholders
            within the campus environment.
          </p>
        </div>
        <div className="about-rating-stats">
          <div className="stat-item">
            <h4>
              <span>{products}+</span>
              <br />
              <h6>Products</h6>
            </h4>
          </div>
          <div className="stat-item">
            <h4>
              <span>{projects}+</span>
              <br />
              <h6>Projects</h6>
            </h4>
          </div>
          <div className="stat-item">
            <h4>
              <span>{clients}+</span>
              <br />
              <h6>Clients</h6>
            </h4>
          </div>
          <div className="stat-item">
            <h4>
              <span>{employees}+</span>
              <br />
              <h6>Employees</h6>
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
